"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCircularBubblePath = void 0;
const constants_1 = require("../../constants");
const utility_paths_1 = require("../utility.paths");
const fixedPointerPosition = 60; // in terms of percentage where 100% = 360 degree = 2 * Math.PI;
const maxPointerBaseLength = Math.PI / 4;
function getCircularBubblePath(circularSpeechBubbleShape) {
    const width = constants_1.SvgDefaults.viewBoxWidth;
    const pointerWidthOption = circularSpeechBubbleShape.pointerWidth;
    const pointerHeightOption = circularSpeechBubbleShape.pointerHeight;
    const pointerPosition = fixedPointerPosition * ((2 * Math.PI) / 100); // constant starting point of the pointer
    const pointerBaseLength = pointerWidthOption * (maxPointerBaseLength / 100); // In terms of angle
    const pointerHeight = (pointerHeightOption * (width / 2)) / 100;
    const radius = width / 4;
    const center = { x: width / 2, y: width / 4 };
    const pointerTipCoordinate = utility_paths_1.getCoordinatesOfArcPoint(center, radius + pointerHeight, pointerPosition);
    const pointerPositionStartCoordinate = utility_paths_1.getCoordinatesOfArcPoint(center, radius, pointerPosition - pointerBaseLength / 2);
    const pointerEndCoordinate = utility_paths_1.getCoordinatesOfArcPoint(center, radius, pointerPosition + pointerBaseLength / 2);
    let path = '';
    if (pointerHeight && pointerBaseLength) {
        path = [
            'M',
            pointerPositionStartCoordinate.x,
            pointerPositionStartCoordinate.y,
            'L',
            pointerTipCoordinate.x,
            pointerTipCoordinate.y,
            'L',
            pointerEndCoordinate.x,
            pointerEndCoordinate.y,
            'A',
            radius,
            radius,
            '0',
            '1',
            '1',
            pointerPositionStartCoordinate.x,
            pointerPositionStartCoordinate.y,
        ].join(' ');
    }
    else {
        if (pointerHeight) {
            path = [
                'M',
                pointerPositionStartCoordinate.x,
                pointerPositionStartCoordinate.y,
                'L',
                pointerTipCoordinate.x,
                pointerTipCoordinate.y,
                'L',
                pointerEndCoordinate.x,
                pointerEndCoordinate.y,
            ].join(' ');
        }
        const endAngleOfCircle = 2 * Math.PI - 0.0001; // Reduce angle by small fraction to render circle
        path = path + ` M${width / 2} 0 ${utility_paths_1.getArc(center, radius, 0, endAngleOfCircle)}Z`;
    }
    return `${path} Z`;
}
exports.getCircularBubblePath = getCircularBubblePath;
//# sourceMappingURL=circularBubble.js.map